import React from 'react';
import {
  Box, Icon, IconName, Text,
} from '@usealloy/component-library';
import { useFormContext } from 'react-hook-form';

import { routes } from '~/helpers/routes';
import type { FormState } from '../types';
import { StyledLink } from '../styles';

export default function Footer() {
  const { getValues } = useFormContext<FormState>();
  const serviceId = getValues('serviceId');
  const serviceName = getValues('serviceName');

  return (
    <Box
      style={{ height: '100%', padding: '0px var(--cl-space-6)' }}
      gap={2}
      justifyContent="flex-start"
    >
      <Icon icon={IconName.Info} />
      <Text lineHeight={4} as="span">
        <b>
          Changes made here will only apply to this {serviceName} node and will overwrite
          default settings.
        </b>
        <StyledLink
          data-dd-action-name="service-local-settings-footer-link"
          to={{
            pathname: routes.v3.dashboard.settings.services,
            hash: `${serviceId}`,
          }}
          target="_blank"
        >
          Edit {serviceName} Settings &rarr;
        </StyledLink>
      </Text>
    </Box>

  );
}
